module.exports = __webpack_public_path__ + "static/Apercu-LightItalic-9261366fbe1ae3e6eca6d1c1b3725055.woff";